import { render, staticRenderFns } from "./PacsDicomViewer.vue?vue&type=template&id=e35f8420&scoped=true&"
import script from "./PacsDicomViewer.vue?vue&type=script&lang=js&"
export * from "./PacsDicomViewer.vue?vue&type=script&lang=js&"
import style0 from "./PacsDicomViewer.vue?vue&type=style&index=0&id=e35f8420&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35f8420",
  null
  
)

export default component.exports